@for (day of days(); track day.date) {
  <section class="changelog__day">
    <h4 class="changelog__date">
      <time [attr.datetime]="day.date">{{ day.label }}</time>
    </h4>
    <ul class="changelog__entries">
      @for (entry of day.entries; track entry.title) {
        <li class="change">
          <div class="change__head">
            <span class="change__kind" [class]="'change__kind--' + entry.kind">
              {{ kindLabels[entry.kind] | translate }}
            </span>
            <strong class="change__title">{{ entry.title | translate }}</strong>
          </div>
          <p class="change__description">{{ entry.description | translate }}</p>
        </li>
      }
    </ul>
  </section>
}
